import React from "react";
import { ColorIconProps, getColorIconSize } from "./utils";

const MetaAnalysisIcon: React.FC<ColorIconProps> = ({
  size = "default",
  className,
}) => {
  return (
    <svg
      width={getColorIconSize(size)}
      height={getColorIconSize(size)}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M1.63367 10.2557C1.63367 6.17554 4.94128 2.86792 9.02143 2.86792L9.02143 10.2557L14.6358 15.0577C13.2809 16.6404 11.2683 17.6435 9.02143 17.6435C4.94128 17.6435 1.63367 14.3358 1.63367 10.2557Z"
        fill="var(--cdl-bg-faint)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.833328 10.2556C0.833328 5.73345 4.49927 2.0675 9.02144 2.0675C9.2337 2.0675 9.43727 2.15183 9.58736 2.30192C9.73746 2.45201 9.82178 2.65558 9.82178 2.86785L9.82178 9.887L15.156 14.4495C15.3174 14.5875 15.4173 14.7839 15.4338 14.9956C15.4502 15.2073 15.3819 15.4169 15.2438 15.5782C13.7433 17.3309 11.5119 18.4437 9.02144 18.4437C4.49927 18.4437 0.833328 14.7778 0.833328 10.2556ZM8.2211 3.71632C4.96042 4.11124 2.43401 6.88839 2.43401 10.2556C2.43401 13.8938 5.3833 16.843 9.02144 16.843C10.7363 16.843 12.2976 16.1885 13.4703 15.1139L8.50122 10.8638C8.32344 10.7118 8.22109 10.4896 8.22109 10.2556L8.2211 3.71632Z"
        fill="currentColor"
      />
      <path
        d="M9.02139 10.2556V17.6434C11.2682 17.6434 13.2808 16.6404 14.6358 15.0577L9.02139 10.2556Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.68659 9.52873C8.40283 9.65942 8.22106 9.94327 8.22106 10.2557V17.6434C8.22106 18.0855 8.57938 18.4438 9.0214 18.4438C11.5118 18.4438 13.7432 17.331 15.2438 15.5782C15.3819 15.4169 15.4502 15.2074 15.4337 14.9957C15.4173 14.784 15.3174 14.5875 15.156 14.4495L9.54161 9.64746C9.3042 9.4444 8.97034 9.39804 8.68659 9.52873ZM13.4702 15.114C12.4828 16.0188 11.2199 16.6258 9.82174 16.795V11.9934L13.4702 15.114Z"
        fill="currentColor"
      />
      <path
        d="M11.9554 2.46692C15.4961 2.46692 18.3663 5.33719 18.3663 8.87784C18.3663 10.4687 17.7869 11.9243 16.8274 13.0449L11.9554 8.87784V2.46692Z"
        fill="var(--cdl-chart-green-base)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.7557 3.32396C15.4753 3.71237 17.566 6.05097 17.566 8.87789C17.566 9.98267 17.2473 11.0117 16.6964 11.8797L12.7557 8.50927V3.32396ZM19.1667 8.87789C19.1667 4.89522 15.9381 1.66663 11.9554 1.66663C11.5134 1.66663 11.1551 2.02495 11.1551 2.46697V8.87789C11.1551 9.11182 11.2574 9.33405 11.4352 9.4861L16.3072 13.6532C16.643 13.9404 17.148 13.9011 17.4354 13.5655C18.5143 12.3053 19.1667 10.6668 19.1667 8.87789Z"
        fill="var(--cdl-chart-green-base)"
      />
    </svg>
  );
};

export default MetaAnalysisIcon;
